var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.39 34.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-10 {\r\n        stroke-width: 1.04px;\r\n      }\r\n\r\n      .cls-10, .cls-20 {\r\n        fill: none;\r\n        stroke: currentColor;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 13.77,
    cy: 11.89,
    rx: 3.17,
    ry: 3.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 17.8,
    y1: 22.78,
    x2: 17.8,
    y2: 26.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 9.93,
    y1: 22.71,
    x2: 9.93,
    y2: 26.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M13.41,17.19h.57c3.84,0,6.95,3.11,6.95,6.95v1.5c0,.41-.33.75-.75.75H7.2c-.41,0-.75-.33-.75-.75v-1.5c0-3.84,3.11-6.95,6.95-6.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M13.69,34.1l-8.52-5.51C.86,25.83.52,22.44.52,18.7V6.72h0c4.42-.91,8.59-2.78,12.21-5.48l.96-.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M13.69,34.1l8.52-5.51c4.31-2.76,4.65-6.15,4.65-9.89V6.72s0,0,0,0c-4.42-.91-8.59-2.78-12.21-5.48l-.96-.72"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/Perfil.7797d6ab4233e8fbff51c6c9dfd18906.svg";
export { ForwardRef as ReactComponent };